// Authored by Joe Kanakaraj
import React, { useState, useEffect } from "react";
import "./styles.scss";
import { useSearch } from "../Contexts/SearchContext";

const Popover = ({ trigger, portal, id, dispatch, componentElement, siteType }) => {
  const { state } = useSearch();

  const {
    sortIndex,
  } = state;

  const [toggle, setToggle] = useState(false);
  const [listToggle, setListToggle] = useState(0);

  const handleClickOutside = (event) => {
    const sortDropdown = componentElement.querySelector('.cmp-popover-portal-list');
    const popover = componentElement.querySelector('.cmp-popover');
    const active = componentElement.querySelector('.cmp-popover-trigger-active');

    if (popover.contains(event.target)) {
      if (!sortDropdown || !sortDropdown.contains(event.target)) {
        setToggle(!active);
      }
    } else {
      setToggle(false);
    }
  }

  useEffect(() => {
    document.addEventListener('click', handleClickOutside, true);
    return () => {
      document.removeEventListener('click', handleClickOutside, true);
    };
  }, []);

  useEffect(() => {
    setListToggle(sortIndex);
  }, [sortIndex]);

  const updateSortType = (item, idx) => {
    dispatch({
      type: "UPDATE_SORT_TYPE_APPLIED",
      payload: item.type,
    });
    setListToggle(idx);
  }

  return (
    <section className="cmp-popover" id={id}>
      <button
        dangerouslySetInnerHTML={{ __html: trigger }}
        className={`cmp-popover-trigger ${
          toggle ? "cmp-popover-trigger-active" : ""
        }`}
        data-testid={"trigger"}
      ></button>
      {portal && (
        <div className="cmp-popover-portal">
          <ul
            className={`cmp-popover-portal-list ${
              toggle ? "cmp-popover-portal-list-active" : ""
            }`}
          >
            {portal.map((item, idx) => (
              <li
                key={idx}
                className={`cmp-popover-portal-list-item ${
                  listToggle === idx
                    ? "cmp-popover-portal-list-item-active"
                    : ""
                }`}
                onClick={() => {
                  setListToggle(null);
                  updateSortType(item, idx);

                  // push event to datalayer
                  window.adobeDataLayer.push({
                    event: window.adobeDataLayerEvents?.component.searchFilterApplied,
                    linkDetails: {
                      clickName: 'Sort By',
                      clickType: 'Sort By Button',
                      clickDestination: 'Sort',
                      clickLocation: siteType,
                      filter: {
                        category: 'Sort',
                        values: item.content
                      }
                    }
                  });
                }}
              >
                {item.content}
              </li>
            ))}
          </ul>
        </div>
      )}
    </section>
  );
};

export default Popover;
